import Application from "../../Application";
import AddDocumentTypeVisibilityLevelsInteractor from "../../documentTypes/interactors/AddDocumentTypeVisibilityLevelsInteractor";
import { IVisibilityLevel } from "../../documentTypes/model/VisibilityLevel";
import Constants from "../common/Constants";

export default class AddLegalViewTypeVisibilityLevelsInteractor {
  private application: Application;
  private addDocumentTypeVisibilityLevelsInteractor: AddDocumentTypeVisibilityLevelsInteractor;

  constructor({ application, addDocumentTypeVisibilityLevels }) {
    this.application = application;
    this.addDocumentTypeVisibilityLevelsInteractor =
      addDocumentTypeVisibilityLevels;
  }

  execute(
    organisationId: number,
    legalViewTypeId: number,
    visibilityLevelListList: IVisibilityLevel[]
  ) {
    return this.addDocumentTypeVisibilityLevelsInteractor.execute(
      `${Constants.organisationsPath}/${organisationId}/${Constants.legalViewTypesPath}/${legalViewTypeId}`,
      visibilityLevelListList
    );
  }
}
